import { Float32BufferAttribute, type BufferGeometry } from 'three';
import { ATTRIBUTE } from '../mesh/attributes';

// Field surfaces read their ditch contrast from aFacade.x (PLAN §3.5). No ground surface reads the
// layout coordinates the mesh builder leaves there, so every vertex of a ground mesh may carry one.
export function withDitchContrast(
  geometry: BufferGeometry,
  contrastOf: (vertex: number) => number
): BufferGeometry {
  const facade = geometry.getAttribute(ATTRIBUTE.facade);
  const values = Float32Array.from(facade.array);
  for (let v = 0; v < facade.count; v++) values[v * 4] = contrastOf(v);
  geometry.setAttribute(ATTRIBUTE.facade, new Float32BufferAttribute(values, 4));
  return geometry;
}
